import { arrayToSimpleObj } from '../../utils';

export const blackGrayAuthorOptions = [
  {
    text: 'Yes',
    value: 'yes',
  },
  {
    text: 'No',
    value: 'no',
  },
];

export const blackGrayAuthorMap = arrayToSimpleObj(blackGrayAuthorOptions);

/**
 * 将多选数组转换为 API 所需的 string 值
 * - ['yes', 'no'] 或 [] → 'all'
 * - ['yes'] → 'yes'
 * - ['no'] → 'no'
 */
export const blackGrayAuthorToApiValue = (selects: string[]): string => {
  if (selects.length === 0 || selects.length === 2) {
    return 'all';
  }
  return selects[0];
};
